<template>
  <v-btn v-bind="$attrs">{{ text }}</v-btn>
</template>
<script>
export default {
  name: 'nx-form-button',
  props: {
    text: String,
  },
};
</script>
